import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { COLORS } from 'consts/colors'
import { Icon } from 'common-components'

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
`

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const CrownBadgeIcon = styled(Icon)`
  display: inline-flex;
  margin-top: -1px;
`

export const DropdownListWrapper = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: scroll;
  ${customizeVerticalScrollbarThumbMixin()}
`

export const ModelItemWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-radius: 8px;
  cursor: pointer;
  border: ${({ $isSelected }) =>
    $isSelected && `1px solid ${COLORS.borderColor}`};
  background-color: ${({ $isSelected }) =>
    $isSelected ? COLORS.primaryExtraLight : 'transparent'};

  &:hover {
    background-color: ${COLORS.primaryExtraLight};
  }
  transition: background-color 0.2s;
`

export const ModelTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`

export const ModelNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const CreditsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
`
